/* Infinite highlighted strip + draggable per-card image galleries. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.16,.84,.24,1)';

  function makeCloneInert(item) {
    item.setAttribute('aria-hidden', 'true');
    item.querySelectorAll('a,button,[tabindex]').forEach(function (control) {
      control.setAttribute('tabindex', '-1');
    });
  }

  function setupGallery(media) {
    var wrap = media.closest('.fd-media-wrap');
    var track = media.querySelector('.fd-media-track');
    var count = parseInt(media.getAttribute('data-count'), 10) || 1;
    var href = media.getAttribute('data-href');
    var index = 0;
    var drag = null;
    if (!wrap || !track || count < 2) return;

    function paint(animate) {
      track.style.transition = animate && !reduced ? 'transform .32s ' + EASE : 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      wrap.classList.toggle('is-browsed', index !== 0);
      wrap.querySelectorAll('.fd-dot').forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
      });
      var previous = wrap.querySelector('.fd-media-nav.prev');
      var next = wrap.querySelector('.fd-media-nav.next');
      if (previous) previous.disabled = index <= 0;
      if (next) next.disabled = index >= count - 1;
    }

    function goTo(nextIndex) {
      index = Math.max(0, Math.min(count - 1, nextIndex));
      paint(true);
    }

    wrap.querySelectorAll('.fd-media-nav').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index + parseInt(button.getAttribute('data-dir'), 10));
      });
    });
    wrap.querySelectorAll('.fd-dot').forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(parseInt(dot.getAttribute('data-i'), 10));
      });
    });
    media.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
      if ((event.key === 'Enter' || event.key === ' ') && href) { event.preventDefault(); window.location.href = href; }
    });
    media.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
      drag = { startX: event.clientX, moved: 0, width: media.getBoundingClientRect().width };
      track.style.transition = 'none';
      wrap.classList.add('is-dragging');
      try { media.setPointerCapture(event.pointerId); } catch (error) {}
    });
    media.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var delta = event.clientX - drag.startX;
      drag.moved = Math.max(drag.moved, Math.abs(delta));
      track.style.transform = 'translateX(' + ((-index * 100) + ((delta / drag.width) * 100)) + '%)';
    });
    media.addEventListener('pointerup', function (event) {
      if (!drag) return;
      var delta = event.clientX - drag.startX;
      var moved = drag.moved;
      var width = drag.width;
      drag = null;
      wrap.classList.remove('is-dragging');
      if (moved > width * 0.18) goTo(index + (delta < 0 ? 1 : -1));
      else if (moved > 6) paint(true);
      else if (href) window.location.href = href;
    });
    media.addEventListener('pointercancel', function () {
      drag = null;
      wrap.classList.remove('is-dragging');
      paint(true);
    });
    paint(false);
  }

  document.querySelectorAll('.fd-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.fd-track');
    if (!track || !track.children.length) return;

    // iOS/iPad Safari doesn't reliably lazy-load images inside a horizontally
    // scrolling strip (cards came up blank): load each card's first photo eagerly.
    track.querySelectorAll('.fd-item').forEach(function (item) {
      var first = item.querySelector('img.fd-slide, .fd-media > img');
      if (first) { first.loading = 'eager'; first.setAttribute('loading', 'eager'); }
    });

    var originals = Array.prototype.slice.call(track.children);
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    originals.forEach(function (item) {
      var firstClone = item.cloneNode(true);
      var lastClone = item.cloneNode(true);
      makeCloneInert(firstClone);
      makeCloneInert(lastClone);
      before.appendChild(firstClone);
      after.appendChild(lastClone);
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    var setWidth = 0;
    var correcting = false;
    function measure() {
      setWidth = track.scrollWidth / 3;
      if (setWidth > 0) carousel.scrollLeft = setWidth;
    }
    function keepInMiddle() {
      if (!setWidth || correcting) return;
      if (carousel.scrollLeft < setWidth * 0.45) {
        correcting = true;
        carousel.scrollLeft += setWidth;
        correcting = false;
      } else if (carousel.scrollLeft > setWidth * 1.55) {
        correcting = true;
        carousel.scrollLeft -= setWidth;
        correcting = false;
      }
    }
    window.requestAnimationFrame(measure);
    window.addEventListener('load', measure, { once: true });
    window.addEventListener('resize', measure);
    carousel.addEventListener('scroll', keepInMiddle, { passive: true });

    var suppressClick = false;
    var stripDrag = null;
    carousel.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      suppressClick = false;
    }, true);
    carousel.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.target.closest('[data-multi]')) return;
      stripDrag = { startX: event.clientX, startScroll: carousel.scrollLeft, moved: 0 };
      carousel.classList.add('is-dragging');
    });
    carousel.addEventListener('pointermove', function (event) {
      if (!stripDrag) return;
      var delta = event.clientX - stripDrag.startX;
      stripDrag.moved = Math.max(stripDrag.moved, Math.abs(delta));
      carousel.scrollLeft = stripDrag.startScroll - delta;
    });
    function endStripDrag() {
      if (!stripDrag) return;
      if (stripDrag.moved > 6) suppressClick = true;
      stripDrag = null;
      carousel.classList.remove('is-dragging');
    }
    carousel.addEventListener('pointerup', endStripDrag);
    carousel.addEventListener('pointerleave', endStripDrag);
    carousel.addEventListener('pointercancel', endStripDrag);

    // Touch screens: the strip itself is what scrolls sideways, and each card
    // keeps its first photo only — no per-card photo dragging (that used to
    // swallow the swipe). Tapping a card just opens the product. Mouse/hover
    // devices keep the hover swap and the galleries as before.
    var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
    carousel.querySelectorAll('.fd-media[data-multi]').forEach(function (media) {
      if (!touchOnly) { setupGallery(media); return; }
      var href = media.getAttribute('data-href');
      if (href) media.addEventListener('click', function () { window.location.href = href; });
    });
  });
})();
